import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-adjustments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/stock-adjustments/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/stock-adjustments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/stock-adjustments/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/stock-adjustments/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const user = () => {
    return httpClient
    .get('/api/v1/stock-adjustments/users')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const product = (Options = {}) => {
    return httpClient
    .get('/api/v1/stock-adjustments/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const sysQty = productId => {
    return httpClient
    .get(`/api/v1/stock-adjustments/${productId}/products`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export default { 
    get, 
    find,
    store,
    update,
    destroy,
    product,
    user,
    sysQty
}
